import axiosClient from "./../apiClient.js";

const baseEndpoint = "/user";

export const userObject = {
  id: 0,
  roleId: 0,
  userName: "",
  role: "",
  password: "",
  oldPassword: "",
  activityDoneBy: "",
};

export const create = (data) => {
  return axiosClient.post(`${baseEndpoint}/create`, JSON.stringify(data));
};

export const changePassword = (data) => {
  return axiosClient.post(
    `${baseEndpoint}/changepassword`,
    JSON.stringify(data)
  );
};

export const validateUser = (data) => {
  return axiosClient.post(`${baseEndpoint}/validateuser`, JSON.stringify(data));
};
